<template>
    <div id="empresa-cadastro">
        <InsuranceModal @close="showModal = false" @confirm="confirmHandler" @cancel="cancelHandler"
            @sendForm="sendForm" v-show="showModal" :title="insuranceOpened.nome"
            :hasAdminPermission="hasAdminPermission" :data="insuranceOpened" :alreadyLinked="alreadyLinked"
            :empresa="empresa" />
        <section id="content">
            <!--start container-->
            <div class="container">
                <TituloPagina :titulo="empresa_tipo" />

                <steps :items="steps" :value="0" />
                <div class="row">
                    <div class="col s12 m12 l12" v-if="corretorasEmpresa.length > 0">
                        <input style="height: 50px; background-color: brown;" type="checkbox" />
                        <div id="card-panel" class="card-panel">
                            <div class="seguradoras-container">
                                <div style="display: flex; flex-direction: row; align-items: center;" :key="index"
                                    v-for="(corretora,
                                        index) in corretorasEmpresa">
                                    <div v-show="isSolicitarFormularioAdicional">
                                        <input type="checkbox" v-model="selectedItems" :value="corretora.nome"
                                            :id="`option-${index}`">
                                        <label :for="`option-${index}`"></label>
                                    </div>
                                    <span @click.stop="openSeguradoraModal(corretora)"
                                        style="display: flex; justify-content: space-between; align-items: center; cursor: pointer;">
                                        <span v-if="corretora.cadastrada">
                                            <i v-if="!corretora.data_desvinculacao" :id="`corretora_${index}`"
                                                style="font-size: 25px" class="material-icons green-text">check</i>

                                            <i v-else style="font-size: 25px"
                                                class="material-icons yellow-text">priority_high</i>
                                        </span>
                                        <span>
                                            <i v-if="!corretora.cadastrada" style="font-size: 25px"
                                                class="material-icons red-text">close</i>
                                        </span>
                                        <span>
                                            {{ corretora.nome }}
                                        </span>

                                    </span>

                                </div>

                            </div>
                            <div v-show="!isSolicitarFormularioAdicional">
                                <div style="display: flex; justify-content: end; text-align: center; padding-top: 50px;">
                                    <div class="button-container">
                                        <button v-show="!isSolicitarFormularioAdicional && hasAdminPermission" class="styled-button"
                                            @click="toggleCheckBoxFomularioAdicional()">
                                            Formulário Adicional
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div v-show="isSolicitarFormularioAdicional">
                                <div style="display: flex; justify-content: end; text-align: center; padding-top: 50px;">
                                    <div class="button-container">
                                        <button class="b-x b-send" @click="sendFormularioAdicional()">Enviar</button>
                                        <button class="b-x b-cancel"
                                            @click="toggleCheckBoxFomularioAdicional()">Cancelar</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <!-- <h4 class="header">Editar empresa</h4> -->
                            <div class="row">
                                <form class="col s12" @submit.prevent="save">
                                    <formulario-empresa v-if="showForm" :empresa.sync="empresa"></formulario-empresa>

                                    <div class="input-field col s12">
                                        <button class="btn btn-default waves-effect waves-light right" type="submit"
                                            name="action">
                                            Salvar
                                            <!-- <i class="material-icons right">send</i> -->
                                        </button>
                                    </div>
                                </form>

                                <!-- <button class="button-production btn btn-default waves-effect waves-light left" v-on:click="production" >
                                    Produção
                                </button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>

<script>
import FormularioEmpresa from "@/components/empresas/Formulario";
import TituloPagina from "@/components/common/TituloPagina";
import { get, put, api, post, api_ff } from "@/helpers/api";
import Message from "@/helpers/message";
import Auth from "@/store/auth";
import {
    DONO,
    GERENTE,
    ESPECIALISTA,
    MASTER,
    PARCEIRO
} from "@/constants/funcionarioCargo.js";
import getPalavra from "@/helpers/language";

import Steps from "@/components/common/Steps.vue";
import swal from "sweetalert2";
import InsuranceModal from "./components/InsuranceModal.vue";

export default {
    components: {
        FormularioEmpresa,
        TituloPagina,
        Steps,
        InsuranceModal
    },
    data: () => ({
        lang: {
            empresa: `Editar ${getPalavra("empresa", true)}`
        },
        empresa: {
            empresa_id: "",
            empresa_nome_fantasia: "",
            empresa_cnpj: "",
            empresa_razao_social: "",
            empresa_tipo_id: "",
            pode_indicar: false,
            envia_email: false,
            plataforma: ""
        },
        showForm: false,
        todasSeguradoras: [],
        showModal: false,
        insuranceOpened: {},
        alreadyLinked: false,
        selectedItems: [],
        isSolicitarFormularioAdicional: false,
    }),

    async created() {
        // verifica se pode acessar componente

        if (
            Auth.getCargoUsuario() !== MASTER &&
            [DONO, GERENTE, PARCEIRO, ESPECIALISTA].indexOf(
                Auth.getCargoUsuario()
            ) === -1
        ) {
            //       this.$router.push('/sempermissao');
        }

        this.getEmpresa();

        this.getSeguradoras();
    },
    computed: {
        empresa_tipo() {
            const palavra = getPalavra("empresa", true);
            return `Editar ${palavra} ${this.empresa.empresa_tipo_id === 2 ? "parceira" : ""
                }`;
        },

        steps() {
            const id = this.$route.params.id;

            return [
                {
                    title: "Dados cadastrais",
                    to: {
                        name: "empresaEditar",
                        params: {
                            id
                        }
                    }
                },
                {
                    title: "Enviar Logo",
                    to: {
                        name: "empresa_upload_logo",
                        params: { id }
                    }
                },
                {
                    title: "Tema",
                    to: {
                        name: "empresa_tema",
                        params: { id }
                    }
                }
            ];
        },

        corretorasEmpresa() {
            if (!this.empresa || !this.todasSeguradoras) return [];

            return this.todasSeguradoras.map(seguradora => {
                const seguradoraData = this.empresa.seguradoras.find(
                    s => s.nome === seguradora.nome
                );

                return {
                    ...seguradora,
                    id: seguradora.id,
                    nome: seguradora.nome,
                    cadastrada: this.empresa.seguradoras.some(
                        s => s.nome === seguradora.nome && s.codigo
                    ),
                    codigo: seguradoraData ? seguradoraData.codigo : null,
                    nivel: seguradoraData ? seguradoraData.nivel : null,
                    superior: seguradoraData ? seguradoraData.superior : null,
                    data_efetivacao: seguradoraData
                        ? seguradoraData.data_efetivacao
                        : null,
                    data_efetivacao: seguradoraData
                        ? seguradoraData.data_efetivacao
                        : null,
                    data_desvinculacao: seguradoraData
                        ? seguradoraData.data_desvinculacao
                        : null,
                    observacao: seguradoraData
                        ? seguradoraData.observacao
                        : null
                };
            });
        },

        hasAdminPermission() {
            const userId = Auth.getUserId();

            if ([3, 4, 11, 259, 20, 258].includes(userId)) return true;
            return false;
        }
    },
    methods: {
        getEmpresa() {
            api.get(`empresa/${this.$route.params.id}`).then(response => {
                this.empresa = { ...response.data.result.data };

                this.showForm = true;
            });
        },
        validateForm() {
            let formValid = true;
            if (this.empresa.empresa_cnpj === "") {
                Message.messageError("Campo CNPJ é obrigatório.");
                formValid = false;
            }
            if (this.empresa.empresa_tipo_id === "") {
                Message.messageError("Campo Tipo é obrigatório.");
                formValid = false;
            }
            if (this.empresa.empresa_razao_social === "") {
                Message.messageError("Campo Razão Social é obrigatório.");
                formValid = false;
            }
            if (this.empresa.empresa_nome_fantasia === "") {
                Message.messageError("Campo Nome Fantasia é obrigatório.");
                formValid = false;
            }
            return formValid;
        },
        save() {
            if (!this.validateForm()) {
                return false;
            }

            let postData = {
                ...this.empresa,
                todasSeguradoras: undefined
            };

            put("empresa/" + this.empresa.empresa_id, postData)
                .then(response => {
                    Message.messageSuccess("Empresa atualizada com sucesso.");

                    this.$router.push({
                        name: "empresa_upload_logo",
                        params: { id: this.empresa.empresa_id }
                    });
                })
                .catch(err => {
                    if (err.response) {
                        const { message: errors } = err.response.data;

                        if (typeof errors === "object") {
                            if (errors.empresa_cnpj) {
                                Message.messageError(errors.empresa_cnpj[0]);
                                return;
                            }
                        }
                    }

                    Message.messageError("Erro ao salvar a empresa.");
                });
        },

        production() {
            this.$router.push({
                name: "empresaProducao",
                params: { id: this.empresa.empresa_id }
            });
        },

        removerCaracteresNaoNumericos(string) {
            return string.replace(/\D+/g, "");
        },

        async getSeguradoras() {
            await get("seguradora").then(response => {
                const data = response.data.result.data;
                this.todasSeguradoras = data;
            });
        },

        async openSeguradoraModal(seguradora) {
            this.alreadyLinked = this.empresa.seguradoras.some(
                s => s.nome === seguradora.nome
            );

            if (this.alreadyLinked) {
                this.insuranceOpened = this.empresa.seguradoras.find(
                    s => s.nome === seguradora.nome
                );
            } else {
                this.insuranceOpened = seguradora;
            }
            this.showModal = true;
        },
        async confirmHandler(seguradora) {
            this.showModal = false;
            const valuesIsFilled =
                !!seguradora.nivel ||
                !!seguradora.codigo ||
                !!seguradora.superior ||
                !!seguradora.data_efetivacao ||
                !!seguradora.observacao;

            if (!valuesIsFilled) {
                swal.fire({
                    icon: "error",
                    title: "Você não preencheu os dados da seguradora!",
                    showConfirmButton: false,
                    timer: 2500
                });
                return;
            }

            if (this.alreadyLinked) {
                await put(`seguradora/${seguradora.seguradora_id}`, {
                    empresa_id: this.empresa.empresa_id,
                    ...seguradora
                })
                    .then(() => {
                        this.getEmpresa();
                        swal.fire("Seguradora atualizada!");
                    })
                    .catch(() => {
                        swal.fire("Erro ao atualizar seguradora");
                    });
                return;
            }

            await post("seguradora", {
                empresa_id: this.empresa.empresa_id,
                ...seguradora
            }).then(response => {
                const data = response.data.result.data;
                this.empresa.seguradoras.push(data);
                swal.fire("Seguradora adicionada!");
            });
        },
        async cancelHandler(seguradora) {
            this.showModal = false;
            await api
                .delete(`seguradora/${seguradora.seguradora_id}`, {
                    empresa_id: this.empresa.empresa_id
                })
                .then(() => {
                    this.getEmpresa();
                    swal.fire("Seguradora deletada com sucesso!");
                })
                .catch(() => {
                    swal.fire("Erro ao deletar seguradora");
                });
        },
        sendForm(seguradora) {
            this.showModal = false;

            post("seguradora/enviar-formularios", {
                empresa_id: this.empresa.empresa_id,
                nome: seguradora.nome
            }, { disableInterceptor: true, })
                .then(() => {
                    swal.fire(
                        `Formulário enviado com sucesso!`
                    );
                })
                .catch(error => {
                    console.log(error);
                    swal.fire({ title: "Ocorreu um erro!", text: error.response.data.statusMessage });
                });
        },
        toggleCheckBoxFomularioAdicional() {
            this.isSolicitarFormularioAdicional = !this.isSolicitarFormularioAdicional;
        },
        sendFormularioAdicional() {
            api_ff.post("atualizar-cadastro/gerar-token/", { 'empresa_id': this.empresa.empresa_id, 'corretoras': this.selectedItems})
                .then(response => {
                    Message.messageSuccess("Formulário Solicitado.");
                    this.toggleCheckBoxFomularioAdicional();
                    this.selectedItems = [];
                })
                .catch(err => {
                    Message.messageError(err.response.data.message);
                });
        }
    }
};
</script>

<style scoped>
.styled-button {
    background-color: var(--color-primary);
    color: white;
    padding: 10px 22px;
    font-size: 16px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.styled-button:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
    transform: translateY(-3px);
}

.styled-button:active {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transform: translateY(1px);
}

.button-production {
    margin-top: -35px;
    margin-left: 25px;
}

.button-container {
    display: flex;  
    gap: 15px;
    /* Espaçamento entre os botões */
}

.b-x {
    background-color: var(--color-primary);
    color: white;
    padding: 10px 22px;
    font-size: 16px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.b-send {
    background-color: #4CAF50;
    /* Verde */
    color: white;
}

.b-cancel {
    background-color: #f44336;
    /* Vermelho */
    color: white;
}

.b-x:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
    transform: translateY(-3px);
}

.b-x:active {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transform: translateY(1px);
}

.checkbox-green[type="checkbox"]:checked+label:before {
    border-right: 2px solid #4caf50;
    border-bottom: 2px solid #4caf50;
}

.seguradoras-container {
    column-count: 4;
    -webkit-column-count: 4;
    -moz-column-count: 4;
}

@media screen and (max-width: 992px) {
    .seguradoras-container {
        column-count: 3;
        -webkit-column-count: 3;
        -moz-column-count: 3;
    }
}

@media screen and (max-width: 768px) {
    .seguradoras-container {
        column-count: 2;
        -webkit-column-count: 2;
        -moz-column-count: 2;
    }
}
</style>

<style lang="scss">
.swal2-close:focus {
    background-color: transparent !important;
    box-shadow: none !important;
}

.swal2-container .swal2-html-container {
    overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/empresas/Editar.vue